import { MouseEvent, useEffect, useState } from 'react';

export interface PopoverInstance {
  /** The element that will trigger the popover */
  anchorElement: HTMLElement | undefined;
  /** Whether the popover is visible or not */
  canRender: boolean;
  /** Callback to open the popover, sets `canRender` to `true` */
  openPopover: (e: MouseEvent) => void;
  /** Callback to close the popover, sets `canRender` to `false` */
  closePopover: () => void;
}

export const usePopover = (): PopoverInstance => {
  /** State to set the anchor element */
  const [anchorElement, setAnchorElement] = useState<HTMLElement | undefined>(
    undefined,
  );
  /** State to render the popover or not */
  const [canRender, setCanRender] = useState(false);

  const openPopover = (event: MouseEvent): void => {
    setAnchorElement(event.currentTarget as HTMLElement);
  };

  const closePopover = (): void => {
    // Refocuses the anchor element when the popover is closed
    anchorElement?.focus();
    setAnchorElement(undefined);
  };

  useEffect(() => {
    if (anchorElement) {
      setCanRender(true);
    } else {
      setCanRender(false);
    }
  }, [anchorElement]);

  return {
    anchorElement,
    canRender,
    openPopover,
    closePopover,
  };
};
